// TODO: remove me after refactoring!
export type ModalType = 'SUCCESS' | 'WARNING' | 'ERROR';

export interface GlobalModal {
  type?: ModalType;
  message: string;
  autoHide?: boolean; // default: true
  timeoutMilliSeconds?: number; // default: 3000
  shouldShow: boolean;
}

/**
 * ページの path を受け取り、該当の path が
 * ヘッダーの透過モード（背景透過・テキストの色が白のモード）になるかどうかを返却する
 *
 * 条件は以下のいずれかのページに該当する場合
 * - トップページ
 * - ストーリー一覧
 * - ストーリー詳細
 * - 体験詳細
 *
 * @param {string} path - ページのパス（/experiences/tomita-somekougei-1/）
 * @returns {boolean}
 */
export const isHeaderBgTransparentMode = (path: string): boolean => {
  // Otonami / Wabunka 共通
  if (path === '/') return true;

  // ストーリー一覧・詳細ページ判定
  if (path.includes('stories')) return true;

  // 特集詳細ページ判定 [1]
  // 末尾のスラッシュありパターン
  if (path.includes('features/') && path.split('/').length === 4) return true;

  // 特集詳細ページ判定 [2]
  // 末尾のスラッシュなしパターン
  if (path.includes('features') && path.split('/').length === 3 && path.split('/')[2].length > 0) return true;

  // 体験詳細ページ判定 [1]
  // 末尾のスラッシュありパターン
  // '/experiences/tomita-somekougei-1/' -> true
  // '/experiences/tomita-somekougei-1/reserve' -> false
  if (/^\/experiences\/[^/]+\/$/.test(path)) return true;

  // 体験詳細ページ判定 [2]
  // 末尾のスラッシュなしパターン '/experiences/tomita-somekougei-1'
  if (/^\/experiences\/[^/]+$/.test(path)) return true;

  // 初めての方LP判定
  if (path.includes('enjoy')) return true;

  // ギフト受け取り導線ページ (/gift/[activationPath]/index.vue)
  // 本来は正規表現を使うべき？
  // e.g. regex = /^\/gift\/[a-zA-Z0-9]+$/;
  if (path.includes('gift/')) return true;

  // アクティベーションページ
  if (path.includes('activation')) return true;

  // マイページ
  if (/^\/mypage\/?$/.test(path)) return true;

  return false;
};

export const isHeaderBgTransparentModeForWabunka = (path: string): boolean => {
  // 英語版トップページ
  if (path === '/') {
    return true;
  }

  if (path.includes('stories')) {
    return true;
  }
  if (path.includes('areas')) {
    return true;
  }
  if (path.includes('themes')) {
    return true;
  }
  if (path.includes('itineraries')) {
    return true;
  }

  // 体験詳細ページ判定 [1]
  // 末尾のスラッシュありパターン
  // '/experiences/tomita-somekougei-1/' -> true
  // '/experiences/tomita-somekougei-1/reserve' -> false
  // :slugの部分のみ存在することを確認するための [^/]
  if (/^\/experiences\/[^/]+\/$/.test(path)) {
    return true;
  }

  // 体験詳細ページ判定 [2]
  // 末尾のスラッシュなしパターン '/experiences/tomita-somekougei-1'
  // :slugの部分のみ存在することを確認するための [^/]
  if (/^\/experiences\/[^/]+$/.test(path)) {
    return true;
  }

  return false;
};
